module.exports = __webpack_public_path__ + "img/nine-pandas-footer.39ffac15.svg";